// extracted by mini-css-extract-plugin
export default {"box":"Home_box__xAP5I","nav":"Home_nav__31df-"};